import { render, staticRenderFns } from "./ReasonsToUse.vue?vue&type=template&id=03f0ca1a&scoped=true&"
import script from "./ReasonsToUse.vue?vue&type=script&lang=js&"
export * from "./ReasonsToUse.vue?vue&type=script&lang=js&"
import style0 from "./ReasonsToUse.vue?vue&type=style&index=0&id=03f0ca1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f0ca1a",
  null
  
)

export default component.exports